
import { ActiveLevel, Material } from "@/types.d";
import { DateTime } from "luxon";
import Vue from "vue";

import { links } from "@/config";
import MarkedLink from "../MarkedLink.vue";
import DownloadCodeLink from "./LevelReviewDownloadHomework.vue";

export default Vue.extend({
    name: "LevelReviewHomeWorksManager",
    components: {
      DownloadCodeLink,
      MarkedLink
    },
    props: {
      level: {
        type: Object as () => ActiveLevel,
        required: true
      },
      reviewIndex: {
        type: Number,
        required: true
      }
    },
    computed: {
      links() {
        return links;
      },
      isUploadAvailable() {
        const isRegDay = this.level.level === 8
          // 8 is Sunday and 11 is Wednesday, for midexam
          ? this.level.day >= 8 && this.level.day < 11
          : this.level._regday;
        return this.reviewIndex === 0 ?  isRegDay : !this.reviewRegistrationClosed;
      },
      reviews(): number[] {
        return this.$store.state.config.reviewsDuration;
      },
      firstUploadDay(): number {
        // usually it's 10, except for midexam
        return this.level.level === 8 ? 8 : this.$store.state.config.daysToDoHomework;
      },
      firstUploadDate(): DateTime {
        const daysToDoHomework = Date.now() - (new Date("2023-12-27")).getTime() < 0 ? this.firstUploadDay + 6 : this.firstUploadDay - 1;
        return this.$dt
          .fromSeconds(+this.level.openDateTS)
          .plus({days: daysToDoHomework});
      },
      lastUploadDay(): number {
        return this.$store.state.config.daysToDoHomework;
      },
      lastUploadDate(): DateTime {
        const daysToDoHomework = Date.now() - (new Date("2023-12-27")).getTime() < 0 ? this.lastUploadDay + 6 : this.lastUploadDay - 1;
        return this.$dt
          .fromSeconds(+this.level.openDateTS)
          .plus({days: daysToDoHomework});
      },
      materials(): {
        [index: string]: Material
      } {
        return this.$store.state.materials.all.other;
      },
      homeworkUploaded(): boolean {
        return !!this.level.homeworks[this.reviewIndex];
      },
      reviewRegistrationClosed(): boolean {
        return this.level.closed ? true : this.level.day > (this.lastUploadDay + this.previousReviewDuration);
      },
      // returns string like вівторок, 31 жовтня
      uploadStartFormatted(): string {
        return this.firstUploadDate.plus({
          days: this.previousReviewDuration
        }).endOf("day").toLocaleString({month: "long", day: "numeric", weekday: "long"});
      },
      // returns string like вівторок, 31 жовтня
      uploadDeadlineFormatted(): string {
        return this.lastUploadDate.plus({
          days: this.previousReviewDuration
        }).endOf("day").toLocaleString({month: "long", day: "numeric", weekday: "long"});
      },
      // uploadDeadlineTime(): string {
      //   return this.firstUploadDate.plus({
      //     days: this.previousReviewDuration
      //   }).endOf("day").toFormat("TT");
      // },
      previousReviewDuration(): number {
        return this.reviewIndex > 0 ? this.reviews[this.reviewIndex - 1] : 0;
      }
    },
    methods: {
      showModal() {
        this.$store.dispatch("modals/set", {
          type: "homeworkUpload",
          visible: true,
          data: {
            level: this.level.level,
            review: this.reviewIndex + 1
          }
        });
      }
    }
  });
